<footer class="Footer">
  <div class="Wrap">
    <div class="row">
      <div class="col-xl-8">
        <p>The Spectrum Database contains licences that can be used for mobile technologies (2G, 3G, 4G, 5G).</p>
        <p>It covers national licences and in some countries the main regional or local licences.</p>
      </div>
      <div class="col-xl-4 AlignRight">
        <p>The information is checked and updated on a monthly basis.</p>
        <p>&copy; Cullen International &ndash; {{todayDate | date : 'MMMM yyyy'}}</p>
      </div>
    </div>
  </div>
</footer>
